import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { changePrintOptions, IChangePrintOptions } from '../../../state/print';
import { PrintPopup } from './index';

export const PrintPopupContainer = connect<
  {
    showComments: boolean;
    showPhones: boolean;
  },
  {
    changePrintOptions(options: IChangePrintOptions): void;
  },
  {
    close(): void;
  }
>(
  (state: IAppState) => {
    const { showComments, showPhones } = state.print;

    return {
      showComments,
      showPhones,
    };
  },
  (dispatch: Dispatch) => ({
    changePrintOptions: (options: IChangePrintOptions) => {
      dispatch(changePrintOptions(options));
    },
  }),
)(PrintPopup);
